import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.013 4.224A4 4 0 0 1 0 3.91C0 1.75 1.79 0 4 0s4 1.75 4 3.91l11.005.005a.99.99 0 0 1 1 .978v11.726c0 .54-.447.978-1 .978H4.015S0 16.043 0 13.686V4.745q0-.271.013-.521M8 5.865v6.844q0 2.062-1.406 2.728a.11.11 0 0 0-.062.097c0 .06.05.108.11.108H18V5.864zM2 3.91v5.712q1-.825 2-.824 1 0 2 .824V3.91c0-1.08-.895-1.955-2-1.955S2 2.83 2 3.91m2 10.754c1.105 0 2-.876 2-1.955s-.895-1.956-2-1.956-2 .876-2 1.956.895 1.955 2 1.955"
    }, null, -1)
  ]))]))
}
export default { render: render }